const AuthState: AuthTypes = {
  accessToken: null,
  jwtToken: null,
  ttl: null,
  createdAt: null,
  error: null,
  user: null,
  permissions: null,
};

export default AuthState;
